import { InjectionToken } from '@angular/core';

/**
 * @deprecated: Use messageFn instead
 */
export const SOFTLINE_FEATURE_MESSAGE_BAR = 'messageBar';
export const SOFTLINE_CONFIG_MESSAGE_BAR_DURATION = new InjectionToken<number>(
  'SOFTLINE_CONFIG_MESSAGE_BAR_DURATION',
  {providedIn: 'root', factory: () => 5000}
);
